import styles from "./ReviewClientTasksBulkSimplifyProgress.module.scss";

type ReviewClientTasksBulkSimplifyProgressProps = {
  percent: number;
  label: string | null;
};

export default function ReviewClientTasksBulkSimplifyProgress(
  props: ReviewClientTasksBulkSimplifyProgressProps,
) {
  return (
    <div
      className={styles.bulkSimplifyProcessing}
      data-testid="review-client-tasks-bulk-simplify-progress"
    >
      <div className={styles.bulkSimplifyProcessingTitle}>
        Creating your client tasks…
      </div>
      <div className={styles.bulkSimplifyProgressTrack} aria-hidden>
        <div
          className={styles.bulkSimplifyProgressFill}
          style={{ width: `${props.percent}%` }}
        />
      </div>
      <div className={styles.bulkSimplifyProgressSubtext} aria-live="polite">
        {props.label ?? "\u00a0"}
      </div>
    </div>
  );
}
